import { render, staticRenderFns } from "./ChatbotWidget.vue?vue&type=template&id=34af8400&scoped=true"
import script from "./ChatbotWidget.vue?vue&type=script&lang=js"
export * from "./ChatbotWidget.vue?vue&type=script&lang=js"
import style0 from "./ChatbotWidget.vue?vue&type=style&index=0&id=34af8400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34af8400",
  null
  
)

export default component.exports